import HttpService from "Services/Http/HttpService";
import { dicontainer } from "DIContainer";
import ServiceRequestError from "Services/ServiceRequestError";
import ContactFormModel from "Models/ContactFormModel";
import { injectable } from "inversify";
import { HttpRequestBodyType, Url } from 'ts-common-utils';

@injectable()
export default class ContactService {
    private _httpService: HttpService  = dicontainer.get(HttpService);

    public sendContactForm(contactForm: ContactFormModel, onSuccess?: () => void, onFailure?: ((details: ServiceRequestError) => void)) {
        return this._httpService.httpPost(
            new Url("./php/contact-form.php"), {
                bodyObject: contactForm,
                sendAs: HttpRequestBodyType.FormUrlEncoded,
                onSuccess: (json: any) => {
                    onSuccess?.();
                },
                onFailure: onFailure
            }
        );
    }
}